import { __extends } from "tslib";
import { deserializeAws_restJson1_1DeleteApnsChannelCommand, serializeAws_restJson1_1DeleteApnsChannelCommand } from "../protocols/Aws_restJson1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DeleteApnsChannelCommand = /** @class */ (function (_super) {
    __extends(DeleteApnsChannelCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteApnsChannelCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DeleteApnsChannelCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteApnsChannelCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1_1DeleteApnsChannelCommand(input, context);
    };
    DeleteApnsChannelCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1_1DeleteApnsChannelCommand(output, context);
    };
    return DeleteApnsChannelCommand;
}($Command));
export { DeleteApnsChannelCommand };
//# sourceMappingURL=DeleteApnsChannelCommand.js.map